import { Component, Input, OnInit, Output,EventEmitter } from '@angular/core';
import { ImgUpload } from 'src/app/models/ImgUpload.model';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-card-image',
    templateUrl: './card-image.component.html',
    styleUrls: ['./card-image.component.css'],
    standalone: false
})
export class CardImageComponent implements OnInit {


  @Input() imagenes:ImgUpload[];
  @Output() ImgUp = new EventEmitter<ImgUpload[]>();
  @Output() Close = new EventEmitter();
  // @Input() tipoImagen:string[];
  constructor() {

   }

  ngOnInit(): void {
  }
  uploadFiles() {
   
    this.ImgUp.emit(this.imagenes);
  }
  quitarImg(img){
    const index: number = this.imagenes.indexOf(img);
    if (index !== -1) {
        this.imagenes.splice(index, 1);
    } 
  }
  cancelar() {
   
    this.Close.emit();
  }
}
